import { useNavigate } from "react-router-dom";
import { ArrowRight, CheckCircle } from "lucide-react";
import { colors } from "./colors";

const TRUST_POINTS = [
  "Erfahrung in Industrie und Gewerbeprojekten",
  "Saubere und sichere Montage",
  "Umsetzung auch bei laufendem Betrieb",
  "Termintreue Projektabwicklung",
];

export function TrustSection() {
  return (
    <section className="py-20 md:py-24" style={{ backgroundColor: colors.white }} data-testid="trust-section">
      <div className="max-w-4xl mx-auto px-6 md:px-12 text-center">
        <h2 className="text-gray-900 font-bold text-xl md:text-2xl lg:text-3xl tracking-tight">
          Warum Unternehmen mit uns arbeiten
        </h2>
        <div className="mt-10 grid grid-cols-1 sm:grid-cols-2 gap-4 max-w-2xl mx-auto">
          {TRUST_POINTS.map((point) => (
            <div
              key={point}
              className="flex items-center gap-3 text-left px-4 py-3.5 rounded-lg bg-gray-50 border border-gray-100"
            >
              <CheckCircle className="w-5 h-5 text-blue-500 shrink-0" strokeWidth={1.5} />
              <span className="text-sm font-medium text-gray-700">{point}</span>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}

export function CtaSection() {
  const navigate = useNavigate();

  return (
    <section id="kontakt" className="py-20 md:py-28 lg:py-32" style={{ backgroundColor: colors.darkBlue }} data-testid="cta-section">
      <div className="max-w-4xl mx-auto px-6 md:px-12 text-center">
        <p className="text-blue-400/50 text-xs uppercase tracking-[0.2em] mb-5">Projekt geplant?</p>
        <h2 className="text-white font-bold text-2xl md:text-3xl lg:text-4xl tracking-tight">
          Wir unterstützen Sie bei der Planung und Umsetzung
        </h2>
        <p className="mt-5 text-white/40 text-base max-w-2xl mx-auto leading-relaxed">
          Moderne LED Beleuchtungssysteme für Industrie, Logistik, Büro und Handelsflächen – von der Beratung bis zur fertig montierten Anlage.
        </p>

        <button
          onClick={() => navigate("/kontakt")}
          className="mt-10 inline-flex items-center gap-3 bg-white text-gray-900 font-medium text-sm px-9 py-4 hover:bg-gray-100 transition-colors"
          data-testid="cta-contact-button"
        >
          Projekt anfragen
          <ArrowRight className="w-5 h-5" />
        </button>

        <p className="mt-6 text-white/25 text-sm">Antwort innerhalb von 24 Stunden.</p>
      </div>
    </section>
  );
}
